import React, { lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import App from '../App';
import Player from '../Player';
import { PlayerProvider } from '../Context/PlayerContext';

const NoticiaDetalhe = lazy(() => import('../NoticiaDetalhe'));
const PromoDetalhe = lazy(() => import('../PromoDetalhe'));
const Programas = lazy(() => import('../Programas'));
const Promocao = lazy(() => import('../Promocao'));
const Drops = lazy(() => import('../Drops'));
const Sobre = lazy(() => import('../Sobre'));
const OndeEstamos = lazy(() => import('../OndeEstamos'));
const PrincipiosEditoriais = lazy(() => import('../PrincipiosEditoriais'));
const Contato = lazy(() => import('../Contato'));
const Manutencao = lazy(() => import('../Manutencao'));
const Programacao = lazy(() => import('../Programacao'));
const PlusNews = lazy(() => import('../PlusNews'));

const RoutesComponent = () => {
  return (
    <PlayerProvider>
      <Router>
        <Suspense fallback={null}>
          <Routes>
          <Route
            path="/programacao"
            element={
              <>
                <Player />
                <Programacao />
              </>
            }
          />
          <Route
            path="/manutencao"
            element={
              <>
                <Player />
                <Manutencao />
              </>
            }
          />
          <Route
            path="/onde-estamos"
            element={
              <>
                <Player />
                <OndeEstamos />
              </>
            }
          />
          <Route
            path="/"
            element={
              <>
                <Player />
                <App />
              </>
            }
          />
          <Route
            path="/drops/:page?"
            element={
              <>
                <Player />
                <Drops />
              </>
            }
          />
          <Route
            path="/drops/page/:page"
            element={
              <>
                <Player />
                <Drops />
              </>
            }
          />
          <Route
            path="/programas/:page?"
            element={
              <>
                <Player />
                <Programas />
              </>
            }
          />
          <Route
            path="/programas/page/:page"
            element={
              <>
                <Player />
                <Programas />
              </>
            }
          />
          <Route
            path="/promocao/:page?"
            element={
              <>
                <Player />
                <Promocao />
              </>
            }
          />
          <Route
            path="/plusnews/:page?"
            element={
              <>
                <Player />
                <PlusNews />
              </>
            }
          />
          <Route
            path="/promocao/page/:page"
            element={
              <>
                <Player />
                <Promocao />
              </>
            }
          />

          <Route
            path="/noticia/:id/:slug"
            element={
              <>
                <Player />
                <NoticiaDetalhe />
              </>
            }
          />
          <Route
            path="/sobre"
            element={
              <>
                {' '}
                <Player />
                <Sobre />{' '}
              </>
            }
          />
          <Route
            path="/principios-editoriais"
            element={
              <>
                {' '}
                <Player />
                <PrincipiosEditoriais />{' '}
              </>
            }
          />
          <Route
            path="/contato"
            element={
              <>
                {' '}
                <Player />
                <Contato />{' '}
              </>
            }
          />
          <Route
            path="/promocao-detalhes/:id/:slug"
            element={
              <>
                <Player />
                <PromoDetalhe />
              </>
            }
          />
          </Routes>
        </Suspense>
      </Router>
    </PlayerProvider>
  );
};

export default RoutesComponent;
